import { useSyncExternalStore } from 'react';

import { getContext } from '@/context';
import { isHostEmbed } from '@/utils/environment/surface';

import getPresetSlugFromHostRoute from './hostRoute';

const readSlug = (): string | null =>
  isHostEmbed() ? getPresetSlugFromHostRoute() : null;

const subscribe = (onChange: () => void): (() => void) => {
  if (!isHostEmbed()) return () => {};
  try {
    return getContext().general.location.subscribe(onChange);
  } catch {
    // Context not ready: nothing to follow yet, and `readSlug` already fell
    // back to the browser path.
    return () => {};
  }
};

/**
 * The preset slug in the host page's path, kept current as the host navigates.
 *
 * gen.ai mounts this app once for the whole site, so going home and into
 * another preset reaches it without a remount — anything derived from the path
 * once would keep describing the first preset.
 */
const useHostRoutePresetSlug = (): string | null =>
  useSyncExternalStore(subscribe, readSlug, () => null);

export default useHostRoutePresetSlug;
